import React, { memo } from 'react';
import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from '@mui/material';
import type { EngagementTimeRange } from '../../utils/engagementAnalytics';

const TIME_RANGE_OPTIONS: { label: string; value: EngagementTimeRange }[] = [
  { label: '7d', value: '7d' },
  { label: '30d', value: '30d' },
  { label: '90d', value: '90d' },
  { label: '180d', value: '180d' },
];

interface TimeRangeToggleProps {
  value: EngagementTimeRange;
  onChange: (value: EngagementTimeRange) => void;
  size?: ToggleButtonGroupProps['size'];
  disabled?: boolean;
}

const TimeRangeToggleComponent: React.FC<TimeRangeToggleProps> = ({
  value,
  onChange,
  size = 'small',
  disabled,
}) => {
  const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: EngagementTimeRange | null) => {
    if (newValue) {
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      color="primary"
      exclusive
      value={value}
      onChange={handleChange}
      size={size}
      disabled={disabled}
    >
      {TIME_RANGE_OPTIONS.map((option) => (
        <ToggleButton key={option.value} value={option.value} aria-label={option.label}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default memo(TimeRangeToggleComponent);

